<template>
  <div
    class="
      d-flex
      flex-column
      justify-content-start
      align-items-start
      w-100
      h-100
    "
  >
    <div
      v-if="sortedList?.length !== 0"
      class="d-flex gap-3 justify-content-start align-items-start"
    >
      <BaseSortButton
        label="No. of customers"
        :sort-is-active="sortOption == sortOptions.customers"
        :reverse-sorting="sortOption == 'reverse-0'"
        @click="sortData(sortOptions.customers)"
      />
      <BaseSortButton
        :label="(metric?.key === 'average' ? 'Average' : 'Total') + ' Amount'"
        :sort-is-active="sortOption == sortOptions.amount"
        :reverse-sorting="sortOption == 'reverse-1'"
        @click="sortData(sortOptions.amount)"
      />
    </div>

    <TopTableCardCells
      v-if="sortedList?.length !== 0"
      :data="[...sortedList]"
    />
    <BaseEmptyState v-else min-height="45vh" />

    <div class="w-100 d-flex justify-content-end align-items-start">
      <BaseSmallButton
        label="All Brands"
        :end-icon="require('@/assets/images/svg/components/right-arrow.svg')"
        @click="$router.push({ name: 'Brands' })"
      />
    </div>
  </div>
</template>
<script>
import BaseSortButton from "@/components/helpers/BaseSortButton.vue";
import BaseSmallButton from "@/components/helpers/BaseSmallButton.vue";
import BaseEmptyState from "@/components/helpers/BaseEmptyState.vue";
import TopTableCardCells from "@/components/TopTableCardCells.vue";

export default {
  components: {
    BaseSortButton,
    BaseSmallButton,
    TopTableCardCells,
    BaseEmptyState,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sortOption: 0,
      sortOptions: {
        customers: 0,
        amount: 1,
      },
    };
  },
  computed: {
    sortedList() {
      const propList = this.data;
      // [0] exit if empty
      if (propList.length === 0) return [];

      return propList.sort((a, b) => {
        let res = 0;

        switch (this.sortOption) {
          case this.sortOptions.customers:
            res =
              Math.abs(b?.tenant_customers_count) -
              Math.abs(a?.tenant_customers_count);
            break;

          case `reverse-${this.sortOptions.customers}`:
            res =
              Math.abs(a?.tenant_customers_count) -
              Math.abs(b?.tenant_customers_count);
            break;

          case this.sortOptions.amount:
            res = Math.abs(this.getSpend(b)) - Math.abs(this.getSpend(a));
            break;

          case `reverse-${this.sortOptions.amount}`:
            res = Math.abs(this.getSpend(a)) - Math.abs(this.getSpend(b));
            break;

          default:
            break;
        }

        return res;
      });
    },
    metric() {
      return this.$store.state.overViewStore.metricFilters;
    },
  },
  methods: {
    sortData(option) {
      this.sortOption =
        this.sortOption == option ? `reverse-${option}` : option;
    },
    getSpend(entry) {
      let value;

      if (this.metric?.key === "average") {
        value = Math.abs(entry?.tenant_customers_avg_spend);
      } else {
        value = Math.abs(entry?.tenant_customers_total_spend);
      }

      return value ?? 0;
    },
  },
};
</script>
<style scoped></style>
